<template>

    <form @submit.prevent="submitKitchen">
        <div class="form-group mb-3">
            <label for="name">Name of your kitchen</label>
            <input type="text" v-model="kitchen.name" class="form-control" id="name"
                placeholder="Authentic Bengali food">
        </div>

        <div class="form-group mb-3">
            <label for="description">Description</label>
            <textarea v-model="kitchen.description" class="form-control" id="description" rows="5"></textarea>
        </div>
        <div class="form-group mb-3">
            <label for="category" class="form-label">Category</label>
            <select class="form-select" v-model="kitchen.categoryId" id="category" aria-label="Select example">
                <option selected>Please select a category</option>

                <option v-for="category in categories" :key="category.id"  :value="category.id">{{ category.category }}</option>
                
            </select>
        </div>

        <div class="form-group mb-3">
            <label for="exampleSelect" class="form-label">Slide to select the cities your service is available</label>
            <div class="form-check form-switch">

                <div v-for="place in places" :key="place.id">
                    <input v-model="selectedPlaces" class="form-check-input"  :id="place.place + '-' + place.id" :value="place.id" type="checkbox">
                <label class="form-check-label" :for="place.place + '-' + place.id">{{ place.place }}</label>

                </div>
                
            </div>
        </div>

        <div class="d-flex justify-content-center">
            <button type="submit" class="btn btn-dark">Submit</button>
        </div>
    </form>

</template>

<script setup>
import api from '@/services/api';
import { computed, onMounted, ref } from 'vue';

import { useKitchenStore } from '@/stores/kitchen';

const store = useKitchenStore();
const kitchen = computed(() => {
    return  store.selectedKitchen;
});

const places = ref([]);

const categories = ref([]);

const selectedPlaces = computed({
    get(){
        return store.selectedPlaces;
    },
    set(newValue){
       store.changeSelectedPlaces(newValue);
    }
    
}); 

console.log(selectedPlaces.value);

console.log(kitchen.value);



async function  submitKitchen() {
    kitchen.value.places = selectedPlaces.value;
    kitchen.value.image = 'https://picsum.photos/200';

   const result = await api.post('/user/admin/kitchen', kitchen.value);

   store.addKitchen(result.data);

   store.toggleKitchenCreateModal();

}


async function getPlaces(){
    const results = await api.get('/user/admin/places');

    places.value = results.data;
}

onMounted(()=>{

    api.get('/user/admin/categories')
         .then((res)=>{
            categories.value = res.data;
         });

   
  getPlaces();

   

})

</script>